import { PRIZE_ASSET_BUCKET } from 'constants/PrizeTiers';

const prizeTierCodeIconMap: Record<string, string> = {
  DAYMAKERboost: `${PRIZE_ASSET_BUCKET}/tier-icons/DAYMAKERboost.svg`,
  DAYMAKER: `${PRIZE_ASSET_BUCKET}/tier-icons/DAYMAKER.svg`,
  Diamond: `${PRIZE_ASSET_BUCKET}/tier-icons/Diamond.svg`,
  Platinum: `${PRIZE_ASSET_BUCKET}/tier-icons/Platinum.svg`,
  Gold: `${PRIZE_ASSET_BUCKET}/tier-icons/Gold.svg`,
  Silver: `${PRIZE_ASSET_BUCKET}/tier-icons/Silver.svg`,
  Bronze: `${PRIZE_ASSET_BUCKET}/tier-icons/Bronze.svg`,
  Treat3: `${PRIZE_ASSET_BUCKET}/tier-icons/Treat.svg`,
  Treat2: `${PRIZE_ASSET_BUCKET}/tier-icons/Treat.svg`,
  Treat1: `${PRIZE_ASSET_BUCKET}/tier-icons/Treat.svg`,
  MONTHLY_GIVEAWAY: `${PRIZE_ASSET_BUCKET}/tier-icons/MONTHLY_GIVEAWAY.svg`,
  CONSOLATION: `${PRIZE_ASSET_BUCKET}/tier-icons/CONSOLATION.png`,
  LEADERBOARD_RAFFLE: `${PRIZE_ASSET_BUCKET}/tier-icons/LEADERBOARD.svg`,
};

export const getDisplayPrizeTierCode = (prizeTierCode: string) =>
  /^Treat\d+$/i.test(prizeTierCode) ? 'Treat' : prizeTierCode;

export const getPrizeTierIcon = (prizeTierCode: string) => {
  if (prizeTierCodeIconMap[prizeTierCode]) {
    return prizeTierCodeIconMap[prizeTierCode];
  }

  return `${PRIZE_ASSET_BUCKET}/tier-icons/token-white.svg`;
};

const prizeTierCodeBackgroundMap: Record<string, string> = {
  DAYMAKERboost: `${PRIZE_ASSET_BUCKET}/background/DAYMAKERboost.svg`,
  DAYMAKER: `${PRIZE_ASSET_BUCKET}/background/DAYMAKER.svg`,
  Diamond: `${PRIZE_ASSET_BUCKET}/background/Diamond.svg`,
  Platinum: `${PRIZE_ASSET_BUCKET}/background/Platinum.svg`,
  Gold: `${PRIZE_ASSET_BUCKET}/background/Gold.svg`,
  Silver: `${PRIZE_ASSET_BUCKET}/background/Silver.svg`,
  Bronze: `${PRIZE_ASSET_BUCKET}/background/Bronze.svg`,
  Treat3: `${PRIZE_ASSET_BUCKET}/background/Treat.svg`,
  Treat2: `${PRIZE_ASSET_BUCKET}/background/Treat.svg`,
  Treat1: `${PRIZE_ASSET_BUCKET}/background/Treat.svg`,
};

export const getPrizeTierBackground = (
  prizeTierCode: string,
  prizeImageLocation: string,
) => {
  if (prizeTierCodeBackgroundMap[prizeTierCode]) {
    return prizeTierCodeBackgroundMap[prizeTierCode];
  } else if (prizeTierCode === 'MONTHLY_GIVEAWAY') {
    return (
      prizeImageLocation || `${PRIZE_ASSET_BUCKET}/background/TOKEN_TOWN.svg`
    );
  } else if (prizeTierCode === 'LEADERBOARD_RAFFLE') {
    return `${PRIZE_ASSET_BUCKET}/background/LEADERBOARD.svg`;
  }
  return `${PRIZE_ASSET_BUCKET}/background/TOKEN_TOWN.svg`;
};
